import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { StandardClusterRenderer } from './standard-cluster.renderer';
import { MapEventsService } from '../../services/map-events.service';
import { Layer } from '../../store/cop/models';
import { MapLayerClusterService } from '../cluster.service';
import { BoundingSuperClusterAlgorithm } from './bounding-super-clusterer.algorithm';
import { ClusterRenderer } from './cluster-renderer';
import { Dataset, DatasetSubtype, DatasetType } from '@app/modules/core/store/models';
import { TrafficCameraClusterRenderer } from './traffic-camera-cluster.renderer';
import { PopupService } from '../popups';

export interface LayerClusterer {
  clusterRenderer: ClusterRenderer;
  markerClusterer: MarkerClusterer;
}

export class LayerClustererFactory {
  public static generateLayerClusterer(
    clusterService: MapLayerClusterService,
    mapEventsService: MapEventsService,
    map: any,
    layer: Layer,
    dataset: Dataset,
    isWorkflowLayerSection: boolean,
    popup: PopupService
  ): LayerClusterer {
    const maxZoomLevel = this.getMaxZoomLevel(layer, dataset, map);
    const clusterRenderer = this.getRenderer(layer, dataset, mapEventsService, clusterService, popup, isWorkflowLayerSection);

    const markerClusterer = new MarkerClusterer({
      algorithm: new BoundingSuperClusterAlgorithm({ maxZoom: maxZoomLevel, radius: 100 }),
      map: map,
      markers: [],
      renderer: clusterRenderer,
      onClusterClick: () => {}
    });

    clusterRenderer.clusterer = markerClusterer;

    return {
      clusterRenderer,
      markerClusterer
    };
  }

  private static getRenderer(
    layer: Layer,
    dataset: Dataset,
    mapEvents: MapEventsService,
    clusterService: MapLayerClusterService,
    popup: PopupService,
    isWorkflowLayerSection: boolean
  ): ClusterRenderer {
    if (dataset.type === DatasetType.Camera && dataset.subtype === DatasetSubtype.Traffic) {
      return new TrafficCameraClusterRenderer(layer, dataset, mapEvents, clusterService, popup, isWorkflowLayerSection);
    }

    return new StandardClusterRenderer(layer, dataset, mapEvents, clusterService, popup, isWorkflowLayerSection);
  }

  private static getMaxZoomLevel(layer: Layer, dataset: Dataset, map: any): number {
    if (dataset.type === DatasetType.Camera && dataset.subtype === DatasetSubtype.Traffic) {
      return map?.maxZoom ?? 20;
    }

    const defaultMaxZoomLevel = layer.displayOptions?.maxClusterZoom || 12;

    return defaultMaxZoomLevel;
  }
}
